import React, { useEffect, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getResource } from '../tools';
import buildInfo from '../config/buildInfo.json';
import './HelpModal.scss';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 800,
    height: 900,
    maxWidth: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#f4f4f4',
    padding: '1em 2.5em',
    position: 'relative',
  },
  title: {
    width: '100%',
    fontSize: '1.25em',
    textAlign: 'center',
    paddingRight: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 8,
  },
  body: {
    padding: '1em 2.5em',
    overflowY: 'auto',
  },
  noteList: {
    padding: 0,
    listStyleType: 'none',
    '& > li': {
      fontSize: '1.25em',
      padding: '0.25em 0.5em',
      cursor: 'pointer',
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',

      '&:hover': {
        background: '#eee',
      },
      '& span': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      },
    },
    '& svg': {
      color: '#999',
      marginRight: '0.25em',
      display: 'inline-block',
    },
  },
  tabs: {
    '& > div': {
      background: '#f5f5f5',
    },
  },
  tabContent: {
    background: '#fff',
    border: '1px solid #ddd',
    borderTop: '1px solid #999',
  },
  heading: {
    fontWeight: 500,
  },
  action: {
    margin: '2em 0 1em',
    textAlign: 'center',
    '& svg': {
      marginRight: 5,
    },
    '& button': {
      border: `1px solid ${theme.palette.primary.light}`,
      paddingRight: 15,
    }
  },
  '@media(max-width: 500px)': {
    header: {
      padding: '1em 1.5em 5px',
    },
    paper: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    body: {
      padding: '1em 1.5em',
    },
  }
}));

const fileNotFound = `<h3 style="margin: 30px 0; text-align: center; color: #999;">Przepraszamy, plik pomocy dla tego ćwiczenia nie jest dostępny.</h3>`

const loadingHtml = '<div style="margin: 30px 0; text-align: center; color: #999;">Wczytuję plik pomocy...</div>';

function HelpModal(props) {
  const [content, setContent] = useState(loadingHtml);
  const [pageTitle, setPageTitle] = useState('Pomoc');
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const { options } = props;
  const { option } = options;

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    let url;
    switch (option) {
      case 'exercise':
        url = `Help/${options.type}.html`;
        setPageTitle(`Pomoc - ${options.title}`);
        break;
      case 'html':
        url = `Help/${options.name}.html`;
        setPageTitle('Pomoc');
        break;
      case 'tabs':
        url = `Help/${options.name}.json`;
        break;
      case 'content':
        setPageTitle(options.title);
        url = null;
        break;
      default:
        url = null;
    }
    if (url) {
      getResource(url)
        .then(response => {
          setContent(response);
          if (option === 'tabs') {
            setPageTitle(response.title);
          }
        })
        .catch(e => setContent(fileNotFound));
    } else {
      if (option === 'content') {
        setContent(option.content);
      } else {
        setContent(fileNotFound);
      }
    }
    // eslint-disable-next-line
  }, [options]);

  const handleClose = () => {
    props.close(false);
  }

  const renderTab = (item, idx) => {
    return (
      <Accordion expanded={expanded === `panel${idx}`} onChange={handleChange(`panel${idx}`)} key={idx}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id={`panel${idx}bh-header`}
        >
          <Typography className={classes.heading}>{item.title}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.tabContent}>
          <div dangerouslySetInnerHTML={{ __html: item.html }}></div>
        </AccordionDetails>
      </Accordion>
    );
  }

  const renderTabs = () => {
    if (typeof content !== 'object') return '';
    return (
      <div className={classes.tabs}>
        {content.tabs.map(renderTab)}
      </div>
    );
  }

  return (
    <Modal open={true} onClose={handleClose} className={classes.wrapper}>
      <div className={classes.paper}>
        <div className={classes.header}>
          <div className={classes.title}>{pageTitle}</div>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.body}>
          {(option === 'html' || option === 'exercise') && <div dangerouslySetInnerHTML={{ __html: content }} className="help-content"></div>}
          {option === 'tabs' && renderTabs()}
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return { config: state.config.main }
}

export default connect(mapStateToProps)(HelpModal);
